import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsBrowserMessages = defineMessages("settings-browser", en);
